import PropTypes from "prop-types";
import React from "react";
import AutoComplete from "../../../components/Comman/AutoComplete";
import TypographyCompo from "../../../components/Comman/TypographyCompo";
import { redColor } from "../../../config/ColorObj";

const BillingPreviewVehicleBar = ({
	vehicleNo,
	vehicleOptions,
	formErrors,
	onChange,
}) => (
	<div className="billing-preview-vehicle-bar">
		<div className="billing-preview-vehicle-label">
			<TypographyCompo className="required-mark" color={redColor}>
				*
			</TypographyCompo>
			<TypographyCompo>Vehicle No.</TypographyCompo>
		</div>
		<div className="billing-preview-vehicle-input">
			<AutoComplete
				keyColName={"id"}
				placeHolder="Select Vehicle No"
				value={vehicleNo}
				name={"vehicleNo"}
				options={vehicleOptions}
				errorText={
					formErrors["vehicleNoError"] ? formErrors["vehicleNoError"] : ""
				}
				isError={
					formErrors["vehicleNoError"] ? formErrors["vehicleNoError"] : ""
				}
				onChange={onChange}
			/>
		</div>
	</div>
);

BillingPreviewVehicleBar.propTypes = {
	vehicleNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
		.isRequired,
	vehicleOptions: PropTypes.array,
	formErrors: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,
};

BillingPreviewVehicleBar.defaultProps = {
	vehicleOptions: [],
};

export default BillingPreviewVehicleBar;
